import { render, staticRenderFns } from "./CoozzyThumbnail.vue?vue&type=template&id=0dc36c9b&scoped=true"
import script from "./CoozzyThumbnail.vue?vue&type=script&lang=js"
export * from "./CoozzyThumbnail.vue?vue&type=script&lang=js"
import style0 from "./CoozzyThumbnail.vue?vue&type=style&index=0&id=0dc36c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc36c9b",
  null
  
)

export default component.exports